import CloseCircle from '../../../assets/icons/CloseCircle';
import ShareIcon from '../../../assets/icons/ShareIcon';
import { getIcLink } from '../../../helpers/getIcLink';
import Button from '../../../ui/Button';
import ButtonNew from '../../../ui/ButtonNew';

function MintedBack({ image, ic }) {
    console.log(image, 'test ic share feature', ic, getIcLink(ic?.tokenAddress, ic?.blockchain?.name));
    // #F5FAFF
    return (
        <>


            <div className="px-[100.7px]">
                <ButtonNew
                    onClick={() => {
                        window.open(image, '_blank');
                    }}
                    variant="blue"
                    className=" py-1 px-6  flex  items-center justify-center gap-2  "
                    size='md'
                    fixedMinWidth={true}

                >
                    <span className='flex items-center gap-2'>
                        <span >
                            {' '}
                            Share{' '}
                        </span>{' '}
                        <ShareIcon fillColor="#fff" />

                    </span>

                </ButtonNew>

            </div>
            <div className="flex items-center justify-center mt-1">

                <div className="flex items-center  gap-1  ">
                    <img className="w-5 h-5 rounded-full" src={ic?.blockchain?.image} alt={ic?.paymentDetails?.
                        paymentBlockchain} />
                    <p className="text-sm flex-1 text-[#fff]">
                        View it on{' '}
                        <a
                            className="underline cursor-pointer "
                            href={getIcLink(ic?.tokenAddress, ic?.blockchain?.name)}
                            target="_blank"
                        >
                            <span className="capitalize ">{ic?.blockchain?.name} </span> blockchain
                        </a>
                    </p>
                </div>
            </div>
        </>
    );
}

export default MintedBack;
